import axios from 'axios';

export const getNestedValue = (key, obj) => {
  return key.split('.').reduce((o, v) => (o && o[v]) || null, obj);
};

export const getFullName = (user) => {
  return (
    (user?.lastName || '') +
    (user?.lastName && user?.firstNames ? ' ' : '') +
    (user?.firstNames || '')
  );
};

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string') return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const downloadFile = async (downloadUrl) => {
  var link;
  try {
    const response = await axios.get(downloadUrl, {
      responseType: 'blob'
    });

    const attachment = response.headers['content-disposition'];
    const fileNameIdx = attachment.indexOf('filename="') + 10;
    const filename = attachment.substring(
      fileNameIdx,
      attachment.indexOf('"', fileNameIdx)
    );

    const decodedFileName = decodeURIComponent(filename);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', decodedFileName);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    return [true, null];
  } catch (error) {
    // https://stackoverflow.com/a/62988821
    if (error?.response?.request?.responseType === 'blob') {
      const isJson = error.response.data?.type === 'application/json';
      error.response.data = (await error?.response?.data?.text()) || '';

      if (isJson && error.response.data) {
        error.response.data = JSON.parse(error.response.data);
      }
    }

    return [null, error.response.data];
  } finally {
    link?.remove();
  }
};

export const getBaseRoute = (user, role, ye = null) => {
  // if (!user || ![0, 1, 2, 3].includes(role)) return '/';
  if (
    !user ||
    !['root', 'admin', 'maintainer', 'handler', 'student'].includes(role)
  )
    return '/';

  if (role === 'root') return '/admin/organizations';

  // Handler
  if (role === 'handler') return `/handler/handling`;

  const path =
    user?.tenants?.[
      user?.tenants?.findIndex((element) => element.id === user?.selectedTenant)
    ]?.path;

  // Admin
  if (role === 'admin' || role === 'maintainer') return `/admin/${path}`;

  // Student
  if (role === 'student') return `/organization/${path}/student`;

  return '/';
};

export const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

export const buildFilterTemplate = (obj) => {
  if (Array.isArray(obj)) {
    return [];
  } else if (typeof obj === 'object' && obj !== null) {
    const result = {};
    for (const key in obj) {
      result[key] = buildFilterTemplate(obj[key]);
    }
    return result;
  } else if (typeof obj === 'boolean') {
    return obj;
  } else {
    return null;
  }
};

export const convertEmptyStringsToNull = (obj) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        convertEmptyStringsToNull(obj[key]);
      } else if (obj[key] === '') {
        obj[key] = null;
      }
    }
  }
  return obj;
};

export function flattenObject(obj) {
  return Object.keys(obj).reduce((acc, key) => {
    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      const nestedObj = flattenObject(obj[key]);
      Object.assign(acc, nestedObj);
    } else {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}

export const replaceLocation = (url) => {
  if (!url) return;
  window.location.replace(url);
}

export function getSemesterInterval(semesters) {
  if (!semesters) return '';

  let semesterStartDate = '';
  let semesterEndDate = '';

  const { startDate = null, endDate = null } = semesters[0] || {};

  if (startDate) {
    semesterStartDate = new Date(startDate);
  }
  if (endDate) {
    semesterEndDate = new Date(endDate);
  }

  return { semesterStartDate, semesterEndDate };
}

export function searchFromValues(term, ...values) {
  if (
    !term ||
    typeof term !== 'string' ||
    !Array.isArray(values) ||
    !values.length
  ) {
    return true;
  }

  const searchTerm = term.toLowerCase();
  return values.some((v) => {
    if (typeof v !== 'string') return false;
    return v.toLowerCase().includes(searchTerm);
  });
};

export function getLocalDatetime(datetime) {
  if (!datetime) return '';

  const d = new Date(datetime);
  const yyyy = d.getFullYear().toString().padStart(4, '0');
  const mm = (d.getMonth() + 1).toString().padStart(2, '0');
  const dd = d.getDate().toString().padStart(2, '0');
  const hh = d.getHours().toString().padStart(2, '0');
  const MM = d.getMinutes().toString().padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${MM}`;
};

export function isFormEnabled(processSettings) {
  if (
    processSettings?.formEnabled == 'scheduled' &&
    processSettings?.formEnabledEnd
  ) {
    return (
      new Date() <
      new Date(processSettings?.formEnabledEnd)
    );
  }

  return processSettings?.formEnabled !== 'false';
}
